<template>
  <div
    class="bothSidePlayer-performance"
    v-if="datas.objectInfo && datas.objectInfo.length == 2"
  >
    <div class="img-box-left">
      <ab-country
        v-if="!isPlayer"
        :countryImg="homeInfor.countryImg"
        :countryName="homeInfor.countryName"
      ></ab-country>
      <ab-player-img
        v-if="isPlayer"
        :playerImg="homeInfor.playerImg"
        :playerNum="homeInfor.playerNum"
        :playerName="`${homeInfor.playerName} ${
          homeInfor.position ? '(' + homeInfor.position + ')' : ''
        }`"
        :countryImg="homeInfor.countryImg"
        :countryName="homeInfor.countryName"
        :countryLogoSize="countryLogoSize"
      ></ab-player-img>
    </div>
    <div class="items-box" v-if="lists && lists.length > 0">
      <div class="item" v-for="(item, index) in lists" :key="index">
        <AbTeamPer :rowData="item"></AbTeamPer>
      </div>
    </div>
    <div class="img-box-right">
      <ab-country
        v-if="!isPlayer"
        :countryImg="awayInfor.countryImg"
        :countryName="awayInfor.countryName"
      ></ab-country>
      <AbPlayerImg
        v-if="isPlayer"
        :playerImg="awayInfor.playerImg"
        :playerNum="awayInfor.playerNum * 1"
        :playerName="`${awayInfor.playerName} ${
          awayInfor.position ? '(' + awayInfor.position + ')' : ''
        }`"
        :countryImg="awayInfor.countryImg"
        :countryName="awayInfor.countryName"
        :countryLogoSize="countryLogoSize"
      ></AbPlayerImg>
    </div>
  </div>
</template>

<script>
// 球队数据对比; 按照现在的主题高度，最多放9个行
import AbCountry from '../components/AbCountry.vue'
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
import AbTeamPer from '../components/AbTeamPer.vue'
export default {
  props: {
    // 必传参数，所有的数据
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isPlayer: {
      default: false,
    },
  },
  data() {
    return {
      defaultValue1: {
        textWidth: 2.778,
        position: 'right',
        mainColor: '#d40503',
        barHeight: 0.556,
      },
      defaultValue2: {
        textWidth: 2.778,
        position: 'left',
        mainColor: '#383d44',
        barHeight: 0.556,
      },
    }
  },
  created() {},
  components: {
    'ab-country': AbCountry,
    AbPlayerImg,
    AbTeamPer,
  },
  computed: {
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return ['1.666vw', '1.666vw']
      } else {
        return ['2.498vw', '1.666vw']
      }
    },
    homeInfor() {
      let homeInfor = {
        playerImg: '',
        playerNum: '',
        playerName: '',
        countryName: '',
        countryImg: '',
        position: '',
      }
      if (this.datas.objectInfo && this.datas.objectInfo[0]) {
        const teamInfor = this.datas.objectInfo[0]
        homeInfor = {
          playerImg: teamInfor.profilePicture,
          playerNum: teamInfor.shirtNumber,
          playerName: teamInfor.playerName,
          countryName: teamInfor.teamName,
          countryImg: teamInfor.teamLogo,
          position: teamInfor.position,
        }
      }
      return homeInfor
    },
    awayInfor() {
      let awayInfor = {
        playerImg: '',
        playerNum: '',
        playerName: '',
        countryName: '',
        countryImg: '',
        position: '',
      }
      if (this.datas.objectInfo && this.datas.objectInfo[1]) {
        const teamInfor = this.datas.objectInfo[1]
        awayInfor = {
          playerImg: teamInfor.profilePicture,
          playerNum: teamInfor.shirtNumber,
          playerName: teamInfor.playerName,
          countryName: teamInfor.teamName,
          countryImg: teamInfor.teamLogo,
          position: teamInfor.position,
        }
      }
      return awayInfor
    },
    lists() {
      if (this.datas.data.dataList && this.datas.data.dataList.length == 2) {
        const home = this.datas.data.dataList[0]
        const away = this.datas.data.dataList[1]
        // const max = this.datas.data.maxList
        return this.datas.statisticsModels.map((modeItem) => {
          const homeValue = home[modeItem.statisticalEn]
          const awayValue = away[modeItem.statisticalEn]
          // const maxValue = max[modeItem.statisticalEn]
          const maxValue =
            home[modeItem.statisticalEn] + away[modeItem.statisticalEn]
          console.debug(homeValue, awayValue, maxValue)
          let homePer = 0,
            awayPer = 0
          if (maxValue !== 0) {
            homePer = ((homeValue / maxValue) * 100).toFixed(1)
            awayPer = (100 - homePer).toFixed(1)
          }
          // if(modeItem.suffix === '%'){
          //   homePer
          // }
          return {
            maxValue,
            homeValue,
            awayValue,
            text: modeItem.name,
            suffix: modeItem.suffix ? modeItem.suffix : '',
            homePer,
            awayPer,
          }
        })
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.bothSidePlayer-performance {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .items-box {
    .item {
      font-size: 0;
      line-height: 1.25vw;
      width: 20.83vw;
      .text {
        display: inline-block;
        font-size: 0.833vw;
        color: var(--mixtmt_greyColor_main);
        width: 6.25vw;
        margin-left: 0.556vw;
        margin-right: 0.556vw;
        text-align: center;
        vertical-align: middle;
      }
    }
  }
}
</style>
